import template from './topdata-conversion-log-list.html.twig';
import './topdata-conversion-log-list.scss';

const { Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Shopware.Component.register('topdata-conversion-log-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            sortBy: 'createdAt',
            sortDirection: 'DESC',
            total: 0,
            filterTriggeredBy: null,
            emailSearchTerm: '',
            emailSearchTimeout: null,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcl_customer_conversion_log');
        },

        triggeredByOptions() {
            return [
                { value: null, label: this.$tc('global.default.all') },
                { value: 'cli', label: this.$tc('TopdataContactLoginSW6.conversionLog.triggeredBy.cli') },
                { value: 'admin_api', label: this.$tc('TopdataContactLoginSW6.conversionLog.triggeredBy.admin_api') },
                { value: 'api', label: this.$tc('TopdataContactLoginSW6.conversionLog.triggeredBy.api') },
            ];
        },

        columns() {
            return [
                {
                    property: 'sourceCustomerEmail',
                    label: this.$tc('TopdataContactLoginSW6.conversionLog.list.column.sourceCustomerEmail'),
                    allowResize: true,
                    primary: true,
                },
                {
                    property: 'sourceCustomerName',
                    label: this.$tc('TopdataContactLoginSW6.conversionLog.list.column.sourceCustomerName'),
                    allowResize: true,
                },
                {
                    property: 'targetCustomerNumber',
                    label: this.$tc('TopdataContactLoginSW6.conversionLog.list.column.targetCustomerNumber'),
                    allowResize: true,
                },
                {
                    property: 'ordersTransferred',
                    label: this.$tc('TopdataContactLoginSW6.conversionLog.list.column.ordersTransferred'),
                    allowResize: true,
                },
                {
                    property: 'contactsMoved',
                    label: this.$tc('TopdataContactLoginSW6.conversionLog.list.column.contactsMoved'),
                    allowResize: true,
                },
                {
                    property: 'contactsDeleted',
                    label: this.$tc('TopdataContactLoginSW6.conversionLog.list.column.contactsDeleted'),
                    allowResize: true,
                },
                {
                    property: 'triggeredBy',
                    label: this.$tc('TopdataContactLoginSW6.conversionLog.list.column.triggeredBy'),
                    allowResize: true,
                },
                {
                    property: 'createdAt',
                    label: this.$tc('TopdataContactLoginSW6.conversionLog.list.column.createdAt'),
                    allowResize: true,
                },
            ];
        },
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));

            const emailTerm = this.emailSearchTerm ? this.emailSearchTerm.trim() : '';
            if (emailTerm) {
                criteria.addFilter(Criteria.contains('sourceCustomerEmail', emailTerm));
            }

            if (this.filterTriggeredBy) {
                criteria.addFilter(Criteria.equals('triggeredBy', this.filterTriggeredBy));
            }

            return this.repository.search(criteria, Shopware.Context.api).then((result) => {
                this.items = result;
                this.total = result.total;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onEmailSearchInput() {
            if (this.emailSearchTimeout) {
                clearTimeout(this.emailSearchTimeout);
            }
            this.emailSearchTimeout = setTimeout(() => {
                this.page = 1;
                this.getList();
            }, 300);
        },

        onFilterChanged() {
            this.page = 1;
            this.getList();
        },

        getTriggeredByLabel(triggeredBy) {
            const key = `TopdataContactLoginSW6.conversionLog.triggeredBy.${triggeredBy}`;
            const translated = this.$tc(key, 0, triggeredBy);
            return translated !== key ? translated : triggeredBy;
        },

        beforeDestroy() {
            if (this.emailSearchTimeout) {
                clearTimeout(this.emailSearchTimeout);
            }
        },
    },
});
